import { render, staticRenderFns } from "./SwitchComponent.vue?vue&type=template&id=95f728fe&scoped=true&"
import script from "./SwitchComponent.vue?vue&type=script&lang=js&"
export * from "./SwitchComponent.vue?vue&type=script&lang=js&"
import style0 from "./SwitchComponent.vue?vue&type=style&index=0&id=95f728fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f728fe",
  null
  
)

export default component.exports